module.exports = "<div class=m-list><ul><li v-for=\"item in userList | search\" :class=\"{ active: session.userId === item.id }\" @click=select(item)><img class=avatar width=30 height=30 :alt=item.name :src=item.img><p class=name>{{item.name}}</p></li></ul></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list.vue
 ** module id = 29
 ** module chunks = 0
 **/